import { render, staticRenderFns } from "./ProductListToShelf.vue?vue&type=template&id=13974382&scoped=true&"
import script from "./ProductListToShelf.vue?vue&type=script&lang=js&"
export * from "./ProductListToShelf.vue?vue&type=script&lang=js&"
import style0 from "./ProductListToShelf.vue?vue&type=style&index=0&id=13974382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13974382",
  null
  
)

export default component.exports